window.addEventListener('load', function() {
    $('.sendComment').on('click', function(e){
        var formData;
        if($('.comments #name').length){
            formData = {
                'action': 'ajaxcomment',
                'content': $("#commentInput").val(), 
                'id': $('#title').data('id'), 
                'name': $('.comments #name').val(),
                'email': $('.comments #email').val()
            };
        }else{
            formData = {
                'action': 'ajaxcomment',
                'content': $("#commentInput").val(), 
                'id': $('#title').data('id'), 
            }
        }
        $('.spinner').removeClass('hidden');
        $('.sendComment').attr('disabled','disabled')
        $('.comments .buttonHolder .error').remove();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_comment_object.ajaxurl,
            data: formData,
            success: function(data){
                var d = new Date();
                //d.m.y / G:i
                /*
                $('.commentSection').append( `<div class="comment">
                <span class="date">${data.comment_author} / ${
                    (("0" + this.getDate()).slice(-2)+"."+("0" + (this.getMonth() + 1)).slice(-2)+"."+d.toString().substr(-2)+" / "+d.getHours()+":"+d.getMinutes()).toString()
                } Uhr</span>
                <span class="text">${data.comment_content}</span>
                <div class="rightAlign">
                    <a href="#" class="reply"><b class="icon-reply"></b></a>
                </div>
                </div>'`);
                */
                $('.sendComment').removeAttr('disabled');
                $('.comments .buttonHolder').append('<span class="success">Danke für Deinen Kommentar. Nach erfolgreicher Prüfung wird er freigeschaltet.</span>');
                $('.spinner').addClass('hidden');
                $('.comments .buttonHolder .success').delay(5000).fadeOut();
                $("#commentInput").val('');
            },
            error: function(xhr){
                console.log(xhr);
                $('.sendComment').removeAttr('disabled');
                $('.comments .buttonHolder').append(`<span class="error">${xhr.responseText}</span>`);
                $('.spinner').addClass('hidden');
            }
        });
        e.preventDefault();
    });
});